import { useStore } from '../store';
import { normalizeRole, isStaffOrAbove, isSuperAdmin, isEndUser } from '../constants/roles';

export function useRole() {
  const user = useStore((s) => s.user);
  const role = normalizeRole(user?.role);
  return {
    role,
    isEndUser: isEndUser(role),
    isStaff: role === 'STAFF',
    isSuperAdmin: isSuperAdmin(role),
    isStaffOrAbove: isStaffOrAbove(role),
  };
}
